
import $ from 'jquery';

import {whenReady} from '../general/Util';
import {StylesAndLooks} from './../listpage/Styleslooks.js';

const getShopTheLookButton = () => {

	const buttonEl = document.getElementById( 'shopTheLook' );
	if ( buttonEl ) {
		return buttonEl;
	}

	const buttonHTML = `
		<div id="shopTheLook" class="en_griditem en_mdl_article_detail__slider_addition en_hidden_desktop_down" data-en-griditem-default="hidden-content-center" data-en-griditem-desktop="1-1-reset-hidden">
			<a href="#detailview_shopthelook" class="shopthelook_button en_button en_button--shrink en_button--min_width en_button--size_large en_icon" data-en-icon="tshirt">Shop the Look</a>
		</div>`;

	const leftContentEl = document.querySelector( '.en_mdl_article_detail__cnt_left' );
	leftContentEl.insertAdjacentHTML( 'beforeend', buttonHTML );
	return leftContentEl.querySelector( '#shopTheLook' );
};

class StylesLoader {

	current_style = 0;
	all_styles = [];

	constructor( containerEl, styles ) {
		this.containerEl = containerEl;
		this.all_styles = styles;

		// Click Handler.
		this.containerEl.addEventListener( 'click', ( ev ) => {
			// Load next style.
			if ( ev.target.closest( '.mdl_styleslooks_detail__pagination a.next' ) ) {
				ev.preventDefault();
				this.set_next_style();
			}
			// Load prev style.
			if ( ev.target.closest( '.mdl_styleslooks_detail__pagination a.prev' ) ) {
				ev.preventDefault();
				this.set_prev_style();
			}
		} );

		// Load Style to Desktop Widget.
		const EN_KO = window.EN_KO;
		EN_KO.functions.initSimpleLazyLoadOnScroll( this.containerEl.parentElement, 'mdl_styleslooks_detail--loaded', () => {
			this.load_style();
		} );
	};

	set_next_style = () => {
		// Loop around.
		if ( this.current_style >= this.all_styles.length -1 ) {
			this.current_style = 0;
		} else {
			this.current_style = this.current_style + 1;
		}
		return this.load_style();
	};

	set_prev_style = () => {
		// Loop around.
		if ( this.current_style <= 0 ) {
			this.current_style = this.all_styles.length - 1;
		} else {
			this.current_style = this.current_style - 1;
		}
		return this.load_style();
	};

	setLoading = ( isLoading ) => {
		if ( isLoading ) {
			this.containerEl.classList.add( 'en_is_loading' );
		} else {
			this.containerEl.classList.remove( 'en_is_loading' );
		}
	}

	load_style = ( style = this.current_style ) => {

		const oxid = document.querySelector( '.article_submit_wrapper' ).getAttribute( 'data-eec-oxid' );
		const url  = new URL( '/' + this.all_styles[ style ].oxseourl + '?articleid=' + oxid, document.baseURI );

		this.setLoading( true );
		return fetch( url.toString() ).then( async( res ) => {
			if ( res.ok ) {
				return await res.text();
			}

			return Promise.reject( await res.text() );
		} ).then( ( response ) => {

			if ( response ) {
				const parser = new DOMParser();
				const responseEl = parser.parseFromString( response, 'text/html' );

				const innerDetailContainerEl = responseEl.querySelector( '#styleslooks_detail' );
				this.containerEl.innerHTML = innerDetailContainerEl.innerHTML;

				// Initialise Styles and Looks.
				StylesAndLooks.initStylesAndLooksLogic( this.containerEl );
				this.containerEl.dispatchEvent( new CustomEvent( 'lazyload.tao', { bubbles: true } ) );
				return true;
			}

		} ).catch( err => {
			console.error( err ); // eslint-disable-line no-console
			return false;
		} ).finally( () => {
			this.setLoading( false );
		} )
	};
}

StylesLoader.initStylesAndLooksPopup = function() {

	const shopTheLookEl = document.getElementById( 'detailview_shopthelook' );
	const articleStylesEl = document.getElementById( 'articleStyles' );

	shopTheLookEl.classList.toggle( 'en_hidden', ! articleStylesEl );
	if ( ! articleStylesEl ) {
		return null;
	}

	// Parse Styles.
	const styles = JSON.parse( decodeURIComponent( articleStylesEl.value ) );

	// A/B Test KOC-7669 - Add additional Stylesloader outside of QV.
	const containerEl = document.getElementById( 'detailview_shopthelook_container' );
	containerEl.ACL_STYLES_LOADER ??= new StylesLoader( containerEl, styles );

	// Hide 8Select Button.
	$( '#details_container div[data-8select-widget-id="sys-button"]' ).remove();
}

/*
** moved from fullproductinfo.tpl
*/
whenReady.then( () => {

	// Add Popup and Load Styles.
	StylesLoader.initStylesAndLooksPopup();
	document.addEventListener( 'finished_change_variant', () => StylesLoader.initStylesAndLooksPopup() );

	// Click on the shopthelook button.
	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target.closest( '.shopthelook_button' ) ) {
			const shopTheLookEl = document.getElementById( 'detailview_shopthelook' );
			if ( shopTheLookEl ) {
				shopTheLookEl.scrollIntoView( { 'behavior': 'smooth' } );
			}
		}
	} );
} );

window.StylesLoader = StylesLoader;
export default StylesLoader;
